import { useQuery } from "@tanstack/react-query";
import { ingestApi } from "../../../api";
import { SourceOrgCategory } from "../../../generated/ingest-api";

export function useListSources(category: SourceOrgCategory, orgId: string) {
  return useQuery({
    queryKey: ["listSources", category, orgId],
    queryFn: () => ingestApi.listSources(category, { org_id: orgId }),
    refetchInterval: 30000,
  });
}
